import { checkbox, inputText, radio, select, defaultControl } from "../controls/index";



const inputType = {
    'text': inputText,
    'radio': radio,
    'checkbox': checkbox,
    '': inputText,
}

const controlType = {
    "select": select,
    "textarea": inputText
}

/**
     * 
     * @param {string} name 
     * @param {object} props 
     * @param {Node} node 
     * @returns {() =>void } 
     */
const direction = (name, props, node) => {
    const nodeName = node.nodeName.toLowerCase();
    const type = node.getAttribute('type') || ''
    if (nodeName === 'input' && typeof inputType[type] === 'function') {
        return inputType[type].call(null, name, props, node);
    } else if (typeof controlType[nodeName] === 'function') {
        controlType[nodeName].call(null, name, props, node);
    } else {
        defaultControl.call(null, name, props, node);
    }
    return () => { }
}

/**
    * 
    * @param {string} name 
    * @param {object} props 
    * @param {Node} node 
    * @returns {() =>void } 
    */
const useBindTrigger = (name, props, node) => {
    direction(name, props, node);
}

export default useBindTrigger;